import { UISystem } from "../../../system/ui/UISystem";
import { title } from "elmtree";
export function AudioScreen() {
    UISystem.appScreen.screens.add([
        {
            id: "audio",
            getElements() {
                return [title("h1", "Audio", "screen-title")];
            },
        },
    ]);
}
